/**
 * Provides a helper to schedule work via requstIdleCallback.
 * @param {Function[]} [work=[]] - A list of synchronous tasks
 * @param {Function} next - Callback function
 */
function idleCallback(work = [], next) {
  requestIdleCallback(
    function chunk(IdleDeadline) {
      // eslint-disable-next-line compat/compat
      while (IdleDeadline.timeRemaining() > 0 && work.length > 0) {
        try {
          work.shift()()
        } catch (err) {
          next(err)
          return
        }
      }

      if (work.length > 0) requestIdleCallback(chunk, { timeout: 1000 })
      else next(null)
    },
    { timeout: 1000 },
  )
}

export default idleCallback
